import MessageProvider from "./MessageProvider"
import './app.scss';
import { Branding, CustomerSupportInfo, LangIcon} from './Models';

import { ApiClient } from './ApiClient';
import DataSource from './DataSource';

export interface AppComponents {
    rootElement: HTMLElement,
    dataSource: DataSource,
    messageProvider: MessageProvider,
    customerSupport: CustomerSupportInfo,
    partnerProDashboardUrl: string,
    branding: Branding,
    langIcon: LangIcon
}

export function setupAppComponents(
    rootElementId:string, onReady:(appComponents:AppComponents) => void) {
        
    document.addEventListener('DOMContentLoaded', function(){ 
        let appRootElement: HTMLElement|null = document.getElementById(rootElementId);
        if(appRootElement == null) {
            console.error("App root element cannot be found.");
            return;
        }

        let baseApiUrl:string|null = appRootElement.getAttribute("data-api-base-url");   
        if(baseApiUrl == null) {
            console.error("App attribute data-api-base-url must not be null.");
            return;
        } 

        let logoUrl:string|null = appRootElement.getAttribute("data-logo-url");
        let bannerImageUrl:string|null = appRootElement.getAttribute("data-banner-image-url");
        let agentId:string|null =appRootElement.getAttribute("data-agent-id");
        let channel:string|null = appRootElement.getAttribute("data-channel");

        let appId:string|null = appRootElement.getAttribute("data-app-id");

        let hotLineNumber:string = appRootElement.hasAttribute("data-hotline-number")?
            appRootElement.getAttribute("data-hotline-number")!: "N/A";
        let customerSupportInfo:CustomerSupportInfo = {
            hotLineNumber: hotLineNumber,
            messengerLink: "#"
        };

        let partnerProDashboardUrl: string = appRootElement.hasAttribute("data-partner-pro-dashboard-url")? 
        appRootElement.getAttribute("data-partner-pro-dashboard-url")!: "";

        let apiClient:ApiClient = new ApiClient(baseApiUrl);
        let messageProvider = new MessageProvider("en");
        let dataSource:DataSource = new DataSource(apiClient, messageProvider);
        let myIcon = appRootElement.getAttribute("data-my-icon-url");
        let enIcon = appRootElement.getAttribute("data-usa-icon-url");

        let appComponents:AppComponents = {
            rootElement: appRootElement,
            dataSource: dataSource,
            messageProvider: messageProvider,
            customerSupport: customerSupportInfo,
            partnerProDashboardUrl: partnerProDashboardUrl,
            branding: {
                logoUrl: logoUrl!,
                bannerImageUrl: bannerImageUrl!,
                channel: channel!,
                agentId: Number(agentId),
                appId: appId!,
            },
            langIcon: {
                en: enIcon!,
                my: myIcon!
            }
        };

        onReady(appComponents);

        /*dataSource.fetchInitialConfigurationData().then(initialConfigData => {
            initAppUI(appRootElement!, logoUrl!, dataSource, messageProvider, initialConfigData, customerSupportInfo);
        });*/     
    });

}
